var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-dialog', _vm._b({ staticClass: "message-view-dialog", attrs: { "title": "内容", "visible": _vm.dialogVisible, "width": "720px" }, on: { "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      } } }, 'el-dialog', _vm.$attrs, false), [_c('div', { staticClass: "view-content" }, [_c('el-tabs', { model: { value: _vm.activeName, callback: function callback($$v) {
        _vm.activeName = $$v;
      }, expression: "activeName" } }, _vm._l(_vm.content, function (item) {
    return _c('el-tab-pane', { key: item.lang, attrs: { "label": item.lang, "name": item.lang } }, [_c('message-content', { attrs: { "message_langs": [item] } })], 1);
  }), 1)], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };